var _path, _path2, _path3, _polygon, _polygon2, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMousePan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 479.11 457.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.4,149.03h-21.68c-45.8,0-83.05,37.26-83.05,83.05v131.27c0,51.77,42.12,93.89,93.9,93.89s93.89-42.12,93.89-93.89V232.08c0-45.8-37.26-83.05-83.05-83.05Zm69.4,214.32c0,44.25-36,80.24-80.24,80.24h0c-44.24,0-80.24-36-80.24-80.24V232.08c0-38.27,31.13-69.4,69.4-69.4h21.68c38.27,0,69.4,31.13,69.4,69.4v131.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.4,184.41c0-1.57-1.27-2.84-2.84-2.84s-2.84,1.27-2.84,2.84v86.28h-65.14c-1.57,0-2.84,1.27-2.84,2.84s1.27,2.84,2.84,2.84h135.97c1.57,0,2.84-1.27,2.84-2.84s-1.27-2.84-2.84-2.84h-65.14v-86.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.3,170.67h-9.28c-29.43,0-53.29,23.86-53.29,53.29v42.14h62.57v-95.43Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "211.98 117 265.18 117 265.18 63.8 303.36 63.8 239.56 0 175.76 63.8 211.98 63.8 211.98 117"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.11 255.24 415.31 191.43 415.31 227.66 362.11 227.66 362.11 280.86 415.31 280.86 415.31 319.04 479.11 255.24"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "63.8 191.43 0 255.24 63.8 319.04 63.8 280.86 117 280.86 117 227.66 63.8 227.66 63.8 191.43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMousePan);
export default __webpack_public_path__ + "static/media/icon-mouse-pan.b0589aac0c29acda3e7926e4c21f27bd.svg";
export { ForwardRef as ReactComponent };